<template>
    <div class="timeline-container">
        <!-- 时间选择器卡片 -->
        <div class="time-selector-card" @click="selTime">
            <div class="time-selector-content">
                <div class="time-icon">
                    <font-awesome-icon icon="clock" />
                </div>
                <div class="time-info">
                    <div class="time-label">结束时间</div>
                    <div class="time-value">{{ showEndTime }}</div>
                </div>
                <!-- <div class="time-arrow">
                    <font-awesome-icon icon="chevron-right" />
                </div> -->
            </div>
        </div>

        <!-- 时间轮盘组件 -->
        <div class="time-wheel-container">
            <Time
                ref="timeRef"
                :width="280"
                @time-data-change="handleTimeDataChange"
                @timer-state-change="handleTimerStateChange"/>
        </div>

        <!-- 当前时间显示卡片 -->
        <div class="current-time-card">
            <div class="current-time-content">
                <div class="current-time-icon">
                    <font-awesome-icon icon="play-circle" />
                </div>
                <div class="current-time-info">
                    <div class="current-time-label">当前时间</div>
                    <div class="current-time-value">{{ showTime2 }}</div>
                </div>
            </div>
        </div>

        <!-- 时间选择弹窗 -->
        <van-popup position="bottom" v-model="show" round>
            <van-datetime-picker
                @confirm="confirmTime"
                @cancel="cancelTime"
                v-model="currentDate"
                title="选择时间"
                :max-date="maxDate"
                type="datetime"/>
        </van-popup>
    </div>
</template>
  
<script>
import dayjs from 'dayjs'
import Time from './Time.vue'

export default {
    components: {
        Time
    },
    props:{
    },
    data() {
        return {
            time2: null,
            maxDate: new Date(2025, 9, 1),
            timer: null,
            show: false,
            currentDate: new Date(),
            startTime: '',
            endTime: '',
        }
    },
    computed: {
        // 显示时间段
        showTime2() {
            return dayjs(this.time2).format('YYYY-MM-DD HH:mm:ss')
        },
        showEndTime() {
            return dayjs(this.endTime).format('YYYY-MM-DD HH:mm:ss')
        }
    },
    mounted() {
        this.initTimes()
    },
    methods: {
        handleTimeDataChange(e) {
            console.log('2345',e)
            // 同步 showTime2 和 Time 组件里的当前时间
            if (e && e.currentTime) {
                // 将 Time 组件的当前时间转换为时间戳并更新 time2
                this.time2 = new Date(e.currentTime).getTime()
            }
            this.$emit('dragTime',e)
        },
        handleTimerStateChange(e) {
            console.log('aaa',e)
            this.$emit('stateChange',e)
        },
        getList(e) {
            this.$refs.timeRef.getListInit(e)
        },
        initTimes() {
            this.endTime = new Date().getTime();
            this.startTime = new Date().getTime() - 2 * 60 * 60 * 1000
            this.time2 = new Date().getTime() - 2 * 60 * 60 * 1000
            this.getDate()
        },
        getDate() {
            const now = new Date();
            // 获取年月日
            const year = now.getFullYear(); 
            const month = now.getMonth();  
            const day = now.getDate();   
            // 获取时分秒
            const hours = now.getHours();         // 时（0-23）
            const minutes = now.getMinutes();     // 分（0-59）
            this.maxDate = new Date(year, month, day,hours,minutes)
        }, 
        confirmTime(e) {
            this.currentDate = new Date(e).getTime()
            this.endTime = new Date(e).getTime();
            this.startTime = new Date(e).getTime() - 2 * 60 * 60 * 1000
            this.time2 = this.startTime
            this.show = false
            this.$emit('setTime',{startTime: this.showTime2,endTime: this.showEndTime})
        },
        getCheck(e) {
            console.log('2345',e)
        },
        cancelTime() {
            this.show = false
        },
        selTime() {
            this.show = true;
        },
    }
}
</script>
  
<style lang="less" scoped>
.container {
    height: 100%;
    margin: 0 auto;
    display: flex;
    position: relative;
    justify-content: center;
    flex-direction: column;
    padding: 1rem;
    gap: 1rem;
    background: var(--gradient-background, linear-gradient(135deg, #fff, #F3F4F6));
}

.selTimeBox {
    background: white;
    border-radius: 1rem;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    padding: 1rem;
    cursor: pointer;
    transition: all 0.3s ease;
    border: 1px solid var(--border-color, #E5E7EB);
    position: relative;
    overflow: hidden;
    font-size: 1rem;
    font-weight: 600;
    color: var(--text-primary, #1F2937);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
}

.selTimeBox::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: var(--gradient-primary, linear-gradient(135deg, #3B82F6, #60A5FA));
}

.selTimeBox::after {
    content: '📅';
    font-size: 1.2rem;
}

.selTimeBox:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}

.selTimeBox:active {
    transform: scale(0.98);
}

.timeShow {
    background: white;
    border-radius: 1rem;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    padding: 1rem;
    border: 1px solid var(--border-color, #E5E7EB);
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    user-select: none;
    font-size: 1rem;
    font-weight: 600;
    color: var(--text-primary, #1F2937);
    position: relative;
    overflow: hidden;
}

.timeShow::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: var(--gradient-primary, linear-gradient(135deg, #10B981, #34D399));
}

.timeShow::after {
    content: '⏰';
    margin-left: 0.5rem;
    font-size: 1.2rem;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .container {
        padding: 0.75rem;
        gap: 0.75rem;
    }

    .selTimeBox,
    .timeShow {
        padding: 0.875rem;
        font-size: 0.9rem;
    }
}
</style>